const ORIGIN_MARKER_ICON = `${THEME_OBJ.template_directory}/images/icons/map-marker.svg`;

export default class GoogleMap {
	constructor(el = null) {
		if (!el || "undefined" === typeof google) return;
		this.mapEl = el;
		this.userOptions = this.mapEl.dataset.options ? JSON.parse(this.mapEl.dataset.options) : [];
		this.markers = [];
		this.init();
		this.events();
	}

	init() {
		this.directionsRenderer = new google.maps.DirectionsRenderer({
			polylineOptions: {
				strokeColor: "#868279",
				strokeOpacity: 1,
			},
			suppressMarkers: true,
		});

		this.response = "";
		this.defaultOptions = {
			lat: "36.1783961",
			lng: "28.0007389",
			zoom: 16,
			zoomControl: true,
			scaleControl: true,
			styles: "",
			scrollwheel: true,
			places_categories: false,
			streetViewControl: false,
			disableDoubleClickZoom: false,
			mapTypeControl: false,
			fullscreenControl: false,
			locations: [],
		};

		this.options = {
			...this.defaultOptions,
			...this.userOptions,
		};

		this.map = new google.maps.Map(this.mapEl, {
			zoom: this.options.zoom,
			zoomControl: this.options.zoomControl,
			scaleControl: this.options.scaleControl,
			scrollwheel: this.options.scrollwheel,
			styles: this.options.styles ?? "",
			streetViewControl: this.options.streetViewControl,
			disableDoubleClickZoom: this.options.disableDoubleClickZoom,
			mapTypeControl: this.options.mapTypeControl,
			fullscreenControl: this.options.fullscreenControl,
			center: {
				lat: parseFloat(this.options.lat),
				lng: parseFloat(this.options.lng),
			},
		});

		const locationPopUpInfoHTML =
			'<a class="location-popup-info flex flex-col gap-6 items-center" id="infowindow-link" href="#">' +
				'<img class="bg-white aspect-square w-[150px] object-contain" id="infowindow-image" src="." alt="The image">' +
				'<span class="title block text-h5 text-center font-afacad" id="infowindow-title"></span>' +
			'</a>';


		this.infoWindow = new google.maps.InfoWindow({
			content: locationPopUpInfoHTML
		});

		this.buildMarkers.bind(this)(this.options.locations);

		this.directionsRenderer.setMap(this.map);
	}

	buildMarkers(locations = null) {
		if (!locations) return;

		this.clearMarkers.bind(this)();
		this.markers = [];

		if (Object.keys(locations).length) {
			Object.entries(locations).map((loc) => {
				let icon = loc[1].icon ?? ORIGIN_MARKER_ICON;

				let m = this.addMarker.bind(this)(icon, {
					lat: parseFloat(loc[1].lat),
					lng: parseFloat(loc[1].lng),
				});

				if (loc[1]['url'] && loc[1]['image']) {
					m.addListener("click", (ev) => {
						this.infoWindow.open({
							anchor: m,
							map: this.map,
						});

						setTimeout(() => {
							document.getElementById('infowindow-image').setAttribute('src', loc[1].image);
							document.getElementById('infowindow-title').textContent = loc[1].title;
							document.getElementById('infowindow-link').setAttribute('href', loc[1].url);
						}, 10);
					});
				}

				this.markers.push(m);
				//
				// if (Object.keys(locations).length === 1) {
				// 	this.map.setCenter(m.getPosition());
				// 	this.map.panTo(m.getPosition());
				// }
			});
		}
	}

	resetAllMarkersIcon(marker = null) {
		this.markers.map((m) => {
			if (m === marker) {
				m.setIcon(ORIGIN_MARKER_ICON);
			} else {
				m.setIcon(ORIGIN_MARKER_ICON);
			}
		});
	}

	selectMarker(m) {

		if (!m) return;

		this.map.setCenter(m.getPosition());
		this.map.panTo(m.getPosition());
		this.map.setZoom(16);

		this.resetAllMarkersIcon.bind(this)(m);
	}

	clearMarkers() {
		for (let i = 0; i < this.markers.length; i++) {
			this.markers[i].setMap(null);
		}

		// this.mapClusterer && this.mapClusterer.clearMarkers();
	}

	addMarker(icon = null, position) {
		return new google.maps.Marker({
			position,
			map: this.map,
			icon: icon ?? false,
			draggable: false,
			zIndex: -20,
		});
	}

	setMarkers(ev) {
		if (Object.keys(ev.detail.locations).length) {
			this.buildMarkers.bind(this)(ev.detail.locations);
		} else {
			this.clearMarkers.bind(this)();
		}
	}

	events() {
		window.addEventListener(
			"gmap.selectMarker",
			(ev) => {
				this.selectMarker.bind(this)(this.markers[ev.detail.realIndex]);
			},
			false
		);


		window.addEventListener(
			"gmap.setMarkers",
			(ev) => {
				this.setMarkers.bind(this)(ev);
			},
			false
		);
	}
}
